import { TaskData, TaskInfoWrapper, TaskItem, TaskTitle } from './styles';

interface ITaskShortInfo {
  sku?: string;
  cost: number;
  price: number;
  quantity?: number;
  isOpenInfo: boolean;
}

export const TaskShortInfo = ({
  isOpenInfo,
  sku,
  cost,
  price,
  quantity,
}: ITaskShortInfo): JSX.Element => (
  <TaskInfoWrapper $isOpenInfo={isOpenInfo}>
    {sku && (
      <TaskItem>
        <TaskTitle>SKU</TaskTitle>
        <TaskData>{sku}</TaskData>
      </TaskItem>
    )}
    <TaskItem>
      <TaskTitle>Cost</TaskTitle>
      <TaskData>${cost}</TaskData>
    </TaskItem>
    <TaskItem>
      <TaskTitle>Sale price</TaskTitle>
      <TaskData>${price}</TaskData>
    </TaskItem>
    {quantity && (
      <TaskItem>
        <TaskTitle>Quantity</TaskTitle>
        <TaskData>{quantity}</TaskData>
      </TaskItem>
    )}
  </TaskInfoWrapper>
);
